<template>
  <div>
    Reports
  </div>
</template>

<script>

export default {
  name: 'Orders',

  components: {
  },
};
</script>
